import React from 'react';

/**
 * Provides reusable handlers to prevent page scroll snapping/jumps
 * while a DnD interaction is active inside the assessment scroll container.
 */
export function useDndScrollLock() {
  const scrollContainerRef = React.useRef<HTMLElement | null>(null);

  React.useLayoutEffect(() => {
    scrollContainerRef.current = document.querySelector(
      '[data-scroll-container="true"]'
    ) as HTMLElement | null;
  }, []);

  const handleDragStart = React.useCallback(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.classList.add('drag-active');
    }
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }, []);

  const cleanupAfterDrag = React.useCallback(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.classList.remove('drag-active');
    }
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }, []);

  const wrapOnDragEnd = React.useCallback(
    <T>(onDragEnd?: (event: T) => void) =>
      (event: T) => {
        cleanupAfterDrag();
        if (onDragEnd) onDragEnd(event);
      },
    [cleanupAfterDrag]
  );

  return {
    onDragStart: handleDragStart,
    wrapOnDragEnd,
  };
}
